import { render, staticRenderFns } from "./Costo.vue?vue&type=template&id=886a4e6e&scoped=true&"
import script from "./Costo.vue?vue&type=script&lang=js&"
export * from "./Costo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886a4e6e",
  null
  
)

export default component.exports